import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-customer-vessel-reviews',
  templateUrl: './customer-vessel-reviews.component.html',
  styleUrls: ['./customer-vessel-reviews.component.scss'],
})
export class CustomerVesselReviewsComponent implements OnInit {
  @Input() vesselReviews;
  @Input() carousel: boolean = false;
  @Input() previewCount: number;
  @Input() verticalLayout: boolean = false;
  @Input() cardView: boolean;
  @Input() autoWrap: boolean = true;
  dateSortedReviews;

  constructor() {}

  ngOnInit(): void {
    this.sortReviewsByDate();
  }

  sortReviewsByDate() {
    if (this.previewCount != null) {
      this.dateSortedReviews = this.vesselReviews.slice(0, this.previewCount);
    }
  }
}
